const pageLoadConstants = {
  countryCode: 'us',
  DLVersion: '1.0.0',
  is404: 'false',
  language: 'en',
  platform: 'web',
  publicVsSecure: 'public',
  siteIdentifier: 'retail',
};
export default pageLoadConstants;
